<template>
    <kgr-profile-part>
        <template #heading>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-row">
                <div class="kgr-postfix__fixed">
                    <h2
                        v-t="'Mitgliedschaft'"
                        class="kgr-headline kgr-headline--h3"
                    ></h2>
                </div>
                <div class="kgr-postfix__fixed">
                    <kgr-member-contract-state-icon :state="memberShortProfile.contractState" />
                </div>
                <kgr-member-dunning-icon v-if="memberShortProfile.isDunningActive" />
            </div>
        </template>

        <template #content>
            <table class="kgr-table">
                <tbody>
                    <tr class="kgr-table__row kgr-table__row--top">
                        <td
                            v-t="'Aktueller Status:'"
                            class="kgr-table__cell"
                        ></td>
                        <td
                            v-t="contractStatusText"
                            class="kgr-table__cell"
                        ></td>
                    </tr>
                    <tr
                        v-if="memberShortProfile.accountsReceivableNumber"
                        class="kgr-table__row kgr-table__row--top"
                    >
                        <td
                            v-t="'memberShortProfile.accountsReceivableNumber'"
                            class="kgr-table__cell"
                        ></td>
                        <td class="kgr-table__cell">
                            {{ memberShortProfile.accountsReceivableNumber }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div class="kgr-postfix__fixed">
                <h4
                    v-t="'Aktueller Vertrag'"
                    class="kgr-headline kgr-headline--h4"
                ></h4>
            </div>
            <table
                v-if="currentContract"
                class="kgr-table"
            >
                <tbody>
                    <tr class="kgr-table__row kgr-table__row--top">
                        <td class="kgr-table__cell">
                            {{ $t('Vertragsart') }}:
                        </td>
                        <td class="kgr-table__cell">
                            {{ $t('memberShortProfile.contractType.' + currentContract.type) }}
                        </td>
                    </tr>
                    <tr
                        v-if="currentContract.membershipNumber"
                        class="kgr-table__row kgr-table__row--top"
                    >
                        <td class="kgr-table__cell">
                            {{ $t('memberShortProfile.membershipNumber') }}:
                        </td>
                        <td class="kgr-table__cell">
                            {{ currentContract.membershipNumber }}
                        </td>
                    </tr>
                    <tr class="kgr-table__row kgr-table__row--top">
                        <td class="kgr-table__cell">
                            {{ $t('Beginn') }}:
                        </td>
                        <td class="kgr-table__cell">
                            {{ currentContract.start.format('DD.MM.YYYY') }}
                        </td>
                    </tr>
                    <tr class="kgr-table__row kgr-table__row--top">
                        <td class="kgr-table__cell">
                            {{ $t('Ende') }}:
                        </td>
                        <td class="kgr-table__cell">
                            {{ currentContract.end ? currentContract.end.format('DD.MM.YYYY') : $t('offen') }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else>
                {{ $t('nicht vorhanden') }}
            </div>
            <br />
            <template v-if="furtherContracts.length">
                <div class="kgr-postfix__fixed">
                    <h4
                        v-t="'Weitere Verträge'"
                        class="kgr-headline kgr-headline--h4"
                    ></h4>
                </div>
                <table class="kgr-table kgr-table--striped">
                    <thead>
                        <tr class="kgr-table__row kgr-table__row--top">
                            <th
                                v-t="'memberShortProfile.membershipNumber'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                            <th
                                v-t="'Vertragsart'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                            <th
                                v-t="'Beginn'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                            <th
                                v-t="'Ende'"
                                class="kgr-table__cell kgr-table__cell--highlight"
                            ></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="contract in memberShortProfile.contractHistory.further()"
                            class="kgr-table__row"
                        >
                            <td class="kgr-table__cell">
                                {{ contract.membershipNumber }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ $t('memberShortProfile.contractType.' + contract.type) }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ contract.start.format('DD.MM.YYYY') }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ contract.end ? contract.end.format('DD.MM.YYYY') : '' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </template>
    </kgr-profile-part>
</template>

<script>
import KgrMemberContractStateIcon from '../MemberContractStateIcon.vue';
import MemberDunningIcon from '../MemberDunningIcon';
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-part-membership',
    components: {
        KgrMemberContractStateIcon,
        'kgr-member-dunning-icon': MemberDunningIcon,
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    data(){
        return {
            currentContract: null,
            furtherContracts: [],
        }
    },
    computed: {
        contractStatusText() {
            if(this.memberShortProfile.contractState.status === 3) {
                return this.$t('memberContractState.' + this.memberShortProfile.contractState.status);
            }
            return this.$t('memberContractState.' + this.memberShortProfile.contractState.contractType + '.' + this.memberShortProfile.contractState.status);
        }
    },
    mounted() {
        this.currentContract = this.memberShortProfile.contractHistory.current()
        this.furtherContracts = this.memberShortProfile.contractHistory.further()
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
